import { Page, View, Image, Text, Link } from '@react-pdf/renderer';
import { styles } from './styles';
import {
  Portfolio,
  PublicEventDetailsResponse,
  ResponsePaginationType,
} from '@hubs101/booking-api-skd-client/lib/types';
import { useTranslation } from 'react-i18next';
import { globalStyles } from '../../styles';
import { APP_HOST } from '@utils/apiHooks';
import { SafeImage } from '../../components/SafeImage';

export interface BookNowPageProps {
  event: PublicEventDetailsResponse;
  coLocatedEvents: PublicEventDetailsResponse[] | undefined;
  portfolios: ResponsePaginationType<Portfolio> | undefined;
  header: JSX.Element;
  footer: JSX.Element;
}

const BookNowPage = ({
  event,
  coLocatedEvents,
  portfolios,
  header,
  footer,
}: BookNowPageProps) => {
  const { t } = useTranslation();

  const bookNowUrl = `${APP_HOST}/events/${event?.slug}${t('book-now-url')}`;
  const partnerUrl = `${APP_HOST}/events/${event?.slug}${t('partnering-packages-url')}`;

  return (
    <Page size="A4" orientation="portrait" style={{ paddingBottom: 100 }}>
      {header}

      <View>
        <Text style={styles.bigTitleLabel}>{t('feel-free-to-contact-us')}</Text>
        <Text
          style={{
            ...globalStyles.bigTitle,
            color: event?.design?.themeColor,
            width: '80%',
          }}
        >
          {t('benefit-from-our-discounts-&-book-now')}
        </Text>
        <View
          style={{
            ...globalStyles.lineBar,
            borderColor: event?.design?.themeColor ?? 'black',
          }}
        />
      </View>

      <View style={styles.contentWrapper}>
        <Text style={styles.boldText}>
          {t('find-the-perfect-ticket-for-your-needs')}
        </Text>
        <Text style={styles.text}>{t('book-now-pdf-paragraph')}</Text>
      </View>

      <View style={styles.buttonWrapper}>
        <Link
          src={partnerUrl}
          style={{
            ...styles.button,
            backgroundColor: event?.design?.themeColor || 'black',
            color: 'white',
          }}
        >
          {t('book-as-a-partner')}
        </Link>
        <Link
          src={bookNowUrl}
          style={{
            ...styles.button,
            backgroundColor: event?.design?.themeColor || 'black',
            color: 'white',
          }}
        >
          {t('book-as-a-delegate')}
        </Link>
      </View>

      <SafeImage
        src={
          'https://media.we-conect.com/images/pdf/agenda/pdf_agenda_voucher.png'
        }
        style={styles.voucherImage}
        debugLabel="agenda-voucher"
      />

      {footer}
    </Page>
  );
};

export default BookNowPage;
